export default __webpack_public_path__ + "static/vector-header-229a147e71cf3c01bd642c62ec29008e.svg";